// 按需引入vant组件库
import Vue from "vue";
import {
    Button,
    NavBar,
    Sidebar,
    SidebarItem,
    Icon,
    Tab,
    Tabs,
    DropdownMenu,
    DropdownItem,
    Col,
    Row,
    Search,
    Badge,
    List,
    Steps,
    Step,
    Popup,
    Cell,
    Image,
    Field,
    CellGroup,
    Loading,
    Collapse,
    CollapseItem,
    Picker,
    Card,
    Swipe,
    SwipeItem,
    SwipeCell,
    Lazyload,
    Empty,
    DatetimePicker,
    Tag,
    PullRefresh,
    Calendar,
    TreeSelect,
    Form,
    Dialog,
    Overlay,
    Uploader,
    RadioGroup,
    Radio,
    ActionSheet,
    Checkbox,
    Sticky,
    ImagePreview,
    NoticeBar,
    Stepper,
    CheckboxGroup 
} from 'vant';
import "vant/lib/index.css";
Vue.use(Button)
Vue.use(CheckboxGroup)
Vue.use(Overlay)
Vue.use(Stepper)
Vue.use(NoticeBar)
Vue.use(Sidebar)
Vue.use(SidebarItem)
Vue.use(NavBar)
Vue.use(Badge)
Vue.use(Sticky)
Vue.use(Icon)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Col)
Vue.use(Row)
Vue.use(Search)
Vue.use(List)
Vue.use(Steps)
Vue.use(Step)
Vue.use(Picker)
Vue.use(Popup)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Image)
Vue.use(Field)
Vue.use(Loading)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Card)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(SwipeCell)
Vue.use(Lazyload)
Vue.use(Empty)
Vue.use(DatetimePicker)
Vue.use(Tag)
Vue.use(PullRefresh)
Vue.use(Calendar)
Vue.use(TreeSelect)
Vue.use(Form)
Vue.use(Dialog)
Vue.use(Uploader)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(ActionSheet)
Vue.use(Checkbox)
Vue.use(ImagePreview)